import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

const BeneficiarioPagoPaisFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='Beneficiario Pago - Pais' md={6} alignRightAt='md' />
      <Col md={6}>
        <Field name='beneficiarioPagoPais'>
          {({ field }) => <Form.InputText {...field} id='input-beneficiarioPagoPais' isInvalid={iError && iTouched} disabled={fIsSubmitting} />}
        </Field>
        {iError && iTouched ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(BeneficiarioPagoPaisFormGroup)
